import { formatMoney } from "./money";

/** @deprecated Prefer formatMoney. Kept for listing call sites. */
export function formatListingRent(amount: number): string {
  return formatMoney(amount);
}
